import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createMeetingRoom, resetMeetingRoomForm } from '../../../../actions/meetingRoom';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowCreateMeetingRoomModal } from '../../../../actions/modal';
import Info from '../../info';

export default function RightPanel(props) {
  const dispatch = useDispatch();
  const [isCreateMRSaving, setIsCreateMRSaving] = useState(false);

  const updateCreateMR = (e) => {
    // Avoid multiple button clicks
    if (isCreateMRSaving) {
      return;
    }

    let areThereErrors = forceValidation(undefined, undefined, 'createMRForm');
    if (!areThereErrors && !window.$(e.target).hasClass('disable')) {
      let cb = (result, response) => {
        if (result) {
          props.searchInEntityPageByName(props.meetingRoomForm.name, () => {
            setIsCreateMRSaving(false);
            dispatch(updateShowCreateMeetingRoomModal(false));
          });
        } else {
          //in case of any failure
          setIsCreateMRSaving(false);
        }
      };

      setIsCreateMRSaving(true);
      // Add check and see which option should be sent
      let postCallOption = props.meetingRoomForm.postCallOption;
      let callerGuestUrl = props.meetingRoomForm.callerGuestUrl;
      let callProviderUrl = props.meetingRoomForm.callProviderUrl;
      let postCallUrl = props.meetingRoomForm.postCallUrl;

      if (props.meetingRoomForm.postCallOption === 1 && props.meetingRoomForm.postCallUrl == '') {
        postCallOption = 0;
      }
      if (props.meetingRoomForm.postCallOption === 2) {
        if (props.meetingRoomForm.callProviderUrl == '' && props.meetingRoomForm.callerGuestUrl == '') {
          postCallOption = 0;
        }
      }

      let newMeetingRoomPayload = {
        name: props.meetingRoomForm.name,
        organisationNetWorkId: props.organisation.networkId,
        videoCallQualityId: props.meetingRoomForm.videoCallQualityId,
        postCallOption: postCallOption,
        postCallUrl: postCallOption == 1 ? postCallUrl : null,
        callProviderUrl: postCallOption == 2 ? callProviderUrl : null,
        callerGuestUrl: postCallOption == 2 ? callerGuestUrl : null,
      };

      // Send the get call
      dispatch(createMeetingRoom(newMeetingRoomPayload, cb));
    }
  };

  const cancelCreateMR = () => {
    if (isCreateMRSaving) {
      //when saving we dont want to cancel
      return;
    }
    if (window.$('.global-message.color-bad-things-bg:visible').length > 0) dispatch(hideGlobalMessage());
    dispatch(updateShowCreateMeetingRoomModal(false));
    resetForm();
  };

  const resetForm = () => {
    dispatch(resetMeetingRoomForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull disable';
  let cancelClass =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl max-width noTopMarginTablet">
        <button
          type="button"
          onClick={updateCreateMR}
          data-group="createMRForm"
          className={isCreateMRSaving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button type="button" onClick={cancelCreateMR} className={cancelClass}>
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info paragraphs={[APP.LANGUAGE.CreateUpdateMeetingRoom.DetailPart1]} />
      </div>
    </div>
  );
}
